import { LoginInfoProvider } from './../ev-dal/login-info.provider';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationService } from './notification.service';
import { CommonRequestResponseService } from './common-request-response.service';
import { CommonAuthenticationService } from './common-authentication.service';

@Injectable()
export class CommonStudentService {
  studentUserId: any;

  constructor(
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonAuthService: CommonAuthenticationService,
    private _loginInfoProvider: LoginInfoProvider
  ) {
    this.studentUserId = this._commonAuthService.getUserId();
  }

  getHeatMapData(studentId?: string, partnerId?: string, HeatmapTypeID?: number,
    grade?: number, quater?: number): Observable<any> {
    const inputJson = {
      studentUserId: studentId || this.studentUserId,
      heatMapTypeID: HeatmapTypeID,
      gradeId: grade,
      quarterId: quater
    };
    this.getCompletedDate()
    return this._commonRequestResponseService.postWithHeader('student/heatmap/', inputJson);
  }

  getCompletedDate() {
    const loginData = this._commonAuthService.getLoginData();
    if (this._loginInfoProvider.roleName.toLowerCase() !== 'student') {
      this.studentUserId = +localStorage.getItem('studentLocalId')
    }
    // if (this._loginInfoProvider.roleName.toLowerCase() !== 'parent') {
    //   this.studentUserId = +localStorage.getItem('parentStudentId')
    // }
    const inputJson = {
      createdBy: loginData.userId,
      studentUserId: this.studentUserId
    };

    this._commonRequestResponseService.postWithHeader('shared/youscience/getcompleteddate', inputJson)
      .subscribe(
        () => {
          // ???
        },
        () => {
          this.notificationService.show('error', 'Error while fetching career assessment data');
        });

    this._commonRequestResponseService.postWithHeader('shared/youscience/viewedsavedcareers', inputJson)
      .subscribe(
        () => {
          // ???
        },
        () => {
          this.notificationService.show('error', 'Error while fetching data');
        });
  }
}
